import { useGetReviewerPermissionRoles } from '@exam-center/admin-proctor-management';
import {
  AdminProctorRequestList,
  AdminProctorRequestListNavigationTabs,
  AdminProctorRequestSummaryStatuses,
  AdminProctorSearchFilterSection,
} from '@exam-center/admin-proctor-request-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Box, Divider, Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminProctorRequestListPage() {
  const { roles } = useGetReviewerPermissionRoles();
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW,
        APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_FIRST_TIER_REVIEW.VIEW,
        APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_SECOND_TIER_REVIEW.VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <PaperSection title='รายการยื่นคำขออนุมัติผู้คุมสอบ'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(4),
              p: theme.spacing(6),
            })}
          >
            {roles.has('supervisor') ? <AdminProctorRequestSummaryStatuses /> : null}
            <AdminProctorSearchFilterSection />
            <Flex
              sx={(theme) => ({
                borderRadius: theme.shape.rounded(2),
                border: '1px solid',
                borderColor: theme.palette.grey[200],
                flexDirection: 'column',
                overflow: 'hidden',
                flexGrow: 1,
              })}
            >
              <AdminProctorRequestListNavigationTabs />
              <Divider
                sx={{
                  mt: '-1px',
                }}
              />
              <AdminProctorRequestList />
            </Flex>
          </Flex>
        </PaperSection>
      </Box>
    </PermissionGuard>
  );
}
